import './styles';

import React from 'react';

const Footer = () => {
    return (
        <div className="Footer-wrapper">
            <div className="Footer">
                <div className="footer-dimensions">
                    This page is provided by{' '}
                    <a href="https://dimensions.ai" target="_blank" rel="noopener noreferrer">
                        Dimensions
                    </a>
                </div>
                <div className="footer-links">
                    <a href="https://dimensions.ai/policies/privacy/" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                    </a>
                    <span className="footer-links-spacer">|</span>
                    <a href="https://dimensions.ai/policies/terms/website/" target="_blank" rel="noopener noreferrer">
                        Legal terms
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Footer;
